import React from "react";
import TimeGeneralInput from "../../input/time-general-input";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import { useComponentBackgroundColor } from "../../common/adaptive-theme-provider";
import { Typography } from "@mhome/ui";

const TimeDetail1Widget = ({ widget, onValueUpdate, pattern }) => {
  const getComponentBgColor = useComponentBackgroundColor();

  const handleValueUpdate = (data) => {
    const updatedWidget = { ...widget, value: data };
    onValueUpdate(updatedWidget);
  };

  const disabled = pattern && pattern.endsWith("_R");
  const showWarning = pattern && pattern.endsWith("_W");

  return (
    <div className="w-full flex flex-col">
      {/* Time Controls Section */}
      <div
        className="flex flex-col rounded-2xl"
        style={{
          padding: "12px",
          backgroundColor: getComponentBgColor("hsl(var(--card))"),
        }}
      >
        <Typography className="mb-3 font-bold flex items-center gap-1 text-sm">
          Time
          {showWarning && (
            <SyncProblemIcon
              fontSize="inherit"
              style={{ color: "hsl(var(--warning))" }}
            />
          )}
        </Typography>

        <div className="flex items-center h-full w-full">
          {widget && (
            <TimeGeneralInput
              valueSpec={widget}
              onChange={handleValueUpdate}
              embedded={false}
              zIndex="var(--z-index-automation-input)"
              disabled={disabled}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TimeDetail1Widget;
